import React, { Component } from "react";
import PropTypes from "prop-types";

import _str from "shared/util/_str";

class Str extends Component {
	static propTypes = {
		children: PropTypes.node,
	};

	shouldComponentUpdate(nextProps) {
		return nextProps.children !== this.props.children;
	}

	render() {
		let str;

		const { children, ...props } = this.props;

		if (typeof (children) === "string") {
			str = children;
		} else if (children && children.length) {
			str = `${children[0]}`;
		} else {
			str = "";
		}

		str = _str(str);

		return (
			<span {...props}>{str}</span>
		);
	}
}

export default Str;



// WEBPACK FOOTER //
// ./src/shared/components/Str.jsx